<div>
    <div class="row margin-top-8">
        <div class="subscription-header" style=" margin-left: 20px;">
            {{'bikeshop.manage_subscription.create_subscription' | translate }}
        </div>
    </div>


    <div class="info-container">
        <div class="subtitle">{{'bikeshop.manage_subscription.subscription_details' | translate}}</div>

        <div class="line-items-container">
            <div class="line-item" *ngIf="paymentData && paymentData.workshopPackage">
                <div>{{paymentData.workshopPackage.plan}}</div>
                <div *ngIf="paymentData.workshopPackage.pricing">
                    {{paymentData.workshopPackage.pricing.currencySymbol}}{{paymentData.workshopPackage.pricing.price.toFixed(2)}}
                </div>
            </div>
            <div class="line-item" *ngIf="paymentData && paymentData.rentalPackage">
                <div>{{paymentData.rentalPackage.plan}}</div>
                <div *ngIf="paymentData.rentalPackage.pricing">
                    {{paymentData.rentalPackage.pricing.currencySymbol}}{{paymentData.rentalPackage.pricing.price.toFixed(2)}}
                </div>
            </div>
            <div class="line-item" *ngIf="paymentData && paymentData.whatsappPackage">
                <div>{{paymentData.whatsappPackage.plan}}</div>
                <div *ngIf="paymentData.whatsappPackage.pricing && paymentData.whatsappPackage.pricing.price">
                    {{paymentData.whatsappPackage.pricing.currencySymbol}}{{paymentData.whatsappPackage.pricing.price.toFixed(2)}}
                </div>
            </div>
        </div>

        <div class="line-items-container total">
            <div class="line-item">
                <div>{{ 'bikeshop.manage_subscription.subscription_amount' | translate }}</div>
                <div>{{ paymentData.workshopPackage && paymentData.workshopPackage.pricing ?
                    paymentData.workshopPackage.pricing.currencySymbol : paymentData.rentalPackage &&
                    paymentData.rentalPackage.pricing ? paymentData.rentalPackage.pricing.currencySymbol :
                    countryData.currencySymbol
                    }}{{getPaymentTotal().toFixed(2)}}</div>
            </div>
        </div>

    </div>

    <div class="info-container">
        <div class="purchase-summary" innerHTML="{{
      'bikeshop.manage_subscription.subscription_payment_summary' | translate :
      {currencySymbol : paymentData.workshopPackage && paymentData.workshopPackage.pricing ?
        paymentData.workshopPackage.pricing.currencySymbol : paymentData.rentalPackage &&
        paymentData.rentalPackage.pricing ? paymentData.rentalPackage.pricing.currencySymbol : countryData.currencySymbol, amount: getPaymentTotal().toFixed(2), dayOfMonth: getDayOfMonth()}
    }}">
        </div>
    </div>

    <div class="info-container">

        <div style="display: flex; justify-content: center;">
            <img style="width: 400px;" src="/assets/secure-stripe-payment-logo.png" />
        </div>


        <div class="row margin-top-16">
            <div class="col-md-12">
                <div id="card-input"></div>
            </div>
        </div>
        <div class="row margin-top-16">
            <div class="col-md-4 label" [ngClass]="{'disabled' : disableCoupons}">
                {{"bikeshop.account.coupon" | translate}}:
            </div>
            <div class="col-md-8">
                <div class="input-container">
                    <input type="text" class="form-control" [(ngModel)]="couponCode" [disabled]="disableCoupons" />
                </div>
            </div>
        </div>


        <div class="row margin-top-8" *ngIf="paymentErrorText">
            <div class="col-md-12 payment-error">{{paymentErrorText}}</div>
        </div>
        <div class="row margin-top-16">
            <div class="col-md-8"></div>
            <div class="col-md-4">
                <div *ngIf="creatingSubscription" style="float: right;">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                    </p-progressSpinner>
                </div>
                <button pButton type="button" *ngIf="!creatingSubscription" class="p-button-raised full-width"
                    [disabled]="creatingSubscription" (click)="submitPayment()"
                    label="{{ 'bikeshop.account.submit_payment' | translate }}"></button>
            </div>
        </div>

    </div>
</div>

<!-- <p-toast position="top-center" styleClass="hubtiger-toast"></p-toast> -->
